import React from 'react'
import Product from '../Components/Product/Product'
import Navbar2 from '../Components/Navbar/Navbar2'
import Footer from '../Components/Footer/Footer'

function HomePage() {
  return (
    <div>
        <Navbar2/>
        <Product/>
        <Footer/>
    </div>
  )
}

export default HomePage